import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { EntityState } from "@@/shared/entity-status";
import type { Except } from "type-fest";
import { z } from "zod";
import { deliveryMethodType } from "../delivery-methods";
import type {
    DigitalDeliveryId} from "./digital-delivery-id";
import {
    digitalDeliveryIdFactory,
    digitalDeliveryIdZodSchema,
} from "./digital-delivery-id";

type DigitalDelivery = {
    readonly _id: DigitalDeliveryId;
    readonly _type: "DIGITAL_DELIVERY";
    readonly _status: EntityState;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly deliveryMethodType: typeof deliveryMethodType.DIGITAL;

    readonly estimatedDeliveryTime: IsoAndUnixTimestamp | undefined;
};

type CreateDigitalDeliveryParams = Except<
    DigitalDelivery,
    "_createdAt" | "_id" | "_status" | "_type" | "deliveryMethodType"
>;

const digitalDeliveryFactory = (
    params: CreateDigitalDeliveryParams,
): DigitalDelivery => {
    return {
        ...params,
        _id: digitalDeliveryIdFactory(),
        _type: "DIGITAL_DELIVERY",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
        deliveryMethodType: deliveryMethodType.DIGITAL,
    };
};

// TODO! BIND BELOW TO ZodSchema<HomeDelivery> TYPE WHEN
// TODO! https://github.com/colinhacks/zod/issues/920
// TODO! HAS BEEN ANSWERED OR FIXED
const digitalDeliveryZodSchema = z.object({
    _id: digitalDeliveryIdZodSchema,
    _type: z.literal("DIGITAL_DELIVERY"),
    _status: z.literal("ACTIVE"),
    _createdAt: isoAndUnixZodSchema,
    deliveryMethodType: z.literal(deliveryMethodType.DIGITAL),
    estimatedDeliveryTime: isoAndUnixZodSchema.or(z.undefined()),
}) as z.ZodSchema<DigitalDelivery>;

export { digitalDeliveryFactory, digitalDeliveryZodSchema };
export type { DigitalDelivery };
